module.exports = __webpack_public_path__ + "4dc48e4af17d7821a4180c6547a50c49.svg";